import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import SelectInput from "../../components/common/SelectInput";
import { IoBusiness, IoHelpCircle, IoSearch } from "react-icons/io5";
import { businessImg, logo } from "../../assets";
import UserDropdown from "./UserDropdown";
import NotificationDropdown from "./NotificationDropdown";
import Help from "./Help";
import { LuMenuSquare } from "react-icons/lu";
import { useSelector } from "react-redux";
import { BusinessContext } from "../../context/BusinessContext";
import { FaSearch, FaLifeRing } from "react-icons/fa";
import Drawer from "react-modern-drawer";
import { GiHelp } from "react-icons/gi";
import {
  KYCStatusBadge,
  notificationToast,
  successToast,
} from "../../helpers/constants";
import { GrCompliance } from "react-icons/gr";
import { CiSearch } from "react-icons/ci";
import { SocketContext } from "../../context/SocketContext";
import AsyncSelect from "react-select/async";
import { NotificationContext } from "../../context/NotificationContext";
import { MdLiveHelp } from "react-icons/md";
import { TbHelpOctagonFilled } from "react-icons/tb";

const Header = ({ sidebarOpen, setSidebarOpen }) => {
  const navigate = useNavigate();

  const { userBusinesses } = useSelector((state) => state.business);

  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const toggleHelp = () => {
    setIsHelpOpen((prevState) => !prevState);
  };

  const { setActiveBusiness, activeBusiness } = useContext(BusinessContext);

  const handleBusinessChange = (e) => {
    setActiveBusiness(e);
  };

  const activeBusinessObject = userBusinesses?.find(
    (business) => business.id === activeBusiness
  );

  const { pathname } = useLocation();

  const [openSearchBar, setOpenSearchBar] = useState(false);

  const { user } = useSelector((state) => state.auth);

  const { socket } = useContext(SocketContext);

  const { saveNotification } = useContext(NotificationContext);

  useEffect(() => {
    if (!socket) return;

    const handleTestNotification = (data) => {
      notificationToast(data?.message);

      saveNotification(data);
    };

    socket.on("paybill_notification", handleTestNotification);

    return () => {
      socket.off("paybill_notification", handleTestNotification);
    };
  }, [socket]);

  return (
    <header className="sticky top-0 z-99 flex w-full bg-white drop-shadow-1">
      <div className="flex flex-grow items-center justify-between px-3.5 py-3.5 shadow-2 md:px-4">
        <div className="flex items-center gap-2 sm:gap-4 lg:hidden">
          <LuMenuSquare
            className="text-3xl text-primary cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              setSidebarOpen(!sidebarOpen);
            }}
            aria-controls="sidebar"
          />

          <Link
            className="hidden sm:block flex-shrink-0 lg:hidden w-20 bg-primary p-1 pt-1.5 rounded"
            to="/dashboard"
          >
            <img src={logo} alt="Logo rounded" />
          </Link>
        </div>

        {user?.kycStatus ? (
          <div className="flex items-center flex-row-reverse gap-2 sm:gap-4">
            <div className="flex gap-1 sm:gap-2 font-semibold items-center text-[0.65rem] sm:text-xs">
              <p className="hidden sm:flex items-center gap-1">
                <GrCompliance className="text-[0.6rem]" />
                Compliance:
              </p>
              <div className="flex items-center gap-1">
                <div
                  className="cursor-pointer"
                  onClick={() => navigate("/kyc")}
                >
                  <KYCStatusBadge status={user?.kycStatus} />
                </div>
                {user?.kycStatus === "Not Verified" && (
                  <p
                    className="hidden md:block font-medium text-blue-600 text-[0.6rem] cursor-pointer hover:underline whitespace-nowrap"
                    onClick={() => navigate("/kyc")}
                  >
                    Click to Verify
                  </p>
                )}
              </div>
            </div>
          </div>
        ) : (
          <p className="text-transparent hidden xl:block">.</p>
        )}

        <Drawer
          size={75}
          open={openSearchBar}
          onClose={() => setOpenSearchBar(false)}
          direction="top"
          className="p-4"
        >
          <div className="relative w-full">
            <input
              type="text"
              placeholder={"Search for everything"}
              className="w-full rounded-md border text-sm border-primary text-primary bg-transparent py-2 pl-1.5 pr-10 outline-none"
            />

            <span className="absolute font-semibold text-sm right-1 top-1 bottom-1 cursor-pointer bg-primary text-white px-2 py-[3px] transition ease-linear rounded hover:bg-primary/70 items-center">
              Search Now
            </span>
          </div>
        </Drawer>

        {!(
          pathname.includes("/business-management") ||
          pathname.includes("/refunds")
        ) &&
          (activeBusinessObject ? (
            <div className="hidden lg:flex items-center gap-1 sm:gap-2 text-primary bg-stroke px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg shadow-inner">
              <IoBusiness className="text-xs sm:text-sm text-success" />
              <span className="font-semibold text-success text-[0.65rem] sm:text-xs whitespace-nowrap">
                Active Business:
              </span>
              <p className="text-black font-bold text-[0.65rem] sm:text-sm truncate max-w-[120px] xl:max-w-none">
                {activeBusinessObject
                  ? activeBusinessObject.businessName
                  : "NA"}
              </p>
            </div>
          ) : (
            <div className="hidden lg:block text-primary bg-stroke px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg shadow-inner">
              <p className="text-black font-bold flex items-center gap-1 sm:gap-2 text-[0.65rem] sm:text-xs whitespace-nowrap">
                No Business Available Yet
                <span
                  className="font-medium text-blue-600 text-[0.65rem] sm:text-xs cursor-pointer underline"
                  onClick={() => navigate("/business-management")}
                >
                  Create One
                </span>
              </p>
            </div>
          ))}

        <div className="flex items-center gap-1.5 sm:gap-2 md:gap-4">
          {/* <div
            className="text-base cursor-pointer bg-primary text-white rounded-full duration-200 p-[0.28rem] sm:p-[0.29rem]"
            onClick={() => setOpenSearchBar(true)}
          >
            <IoSearch />
          </div> */}

          <div
            data-tooltip-id="my-tooltip"
            data-tooltip-content="Help & Support"
            onClick={toggleHelp}
            className="cursor-pointer bg-gradient-to-br from-blue-50 to-blue-100 hover:from-blue-100 hover:to-blue-200 p-2 sm:p-2.5 rounded-full transition-all duration-200 shadow-sm hover:shadow-md"
          >
            <GiHelp className="text-lg sm:text-xl text-blue-600" />
          </div>

          <NotificationDropdown />

          <AsyncSelect
            isDisabled={pathname.includes("/business-management")}
            cacheOptions
            loadOptions={(inputValue, callback) => {
              const opts = userBusinesses
                ?.filter((b) =>
                  b.businessName
                    .toLowerCase()
                    .includes(inputValue.toLowerCase())
                )
                .map((b) => ({ label: b.businessName, value: b.id }));
              callback(opts);
            }}
            defaultOptions={userBusinesses?.map((b) => ({
              label: b.businessName,
              value: b.id,
            }))}
            placeholder="Select business"
            value={
              activeBusiness
                ? {
                    label: userBusinesses?.find((b) => b.id === activeBusiness)
                      ?.businessName,
                    value: activeBusiness,
                  }
                : null
            }
            onChange={(opt) => {
              handleBusinessChange(opt ? opt.value : null);
            }}
            isClearable
            components={{ ClearIndicator: () => null }}
            className="m-0 text-xs hidden sm:block"
            styles={{
              control: (base, state) => ({
                ...base,
                backgroundColor: state.isDisabled ? "gray" : "#5e033e",
                borderColor: "#FFFFFF",
                color: state.isDisabled ? "lightgray" : "#FFFFFF",
                borderRadius: "6px",
                boxShadow: "none",
                minWidth: "140px",
                maxWidth: "180px",
                fontSize: "0.675rem",
                "&:hover": { borderColor: "#FFFFFF" },
              }),
              singleValue: (base) => ({
                ...base,
                color: (state) => (state.isDisabled ? "#9ca3af" : "#FFFFFF"),
              }),
              input: (base) => ({
                ...base,
                color: "#FFFFFF",
              }),
              placeholder: (base) => ({
                ...base,
                color: "#FFFFFF",
              }),
              dropdownIndicator: (base) => ({
                ...base,
                color: "#FFFFFF",
                "&:hover": { color: "#EEEEEE" },
              }),
              menu: (base) => ({
                ...base,
                borderRadius: "6px",
                boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                border: "1px solid #ddd",
                minWidth: "140px",
              }),
              option: (base, state) => ({
                ...base,
                // padding: "4px 15px",
                backgroundColor: state.isSelected
                  ? "#1E40AF"
                  : state.isFocused
                  ? "#f5f5f5"
                  : "white",
                color: state.isSelected ? "#FFFFFF" : "#333",
                cursor: "pointer",
              }),
            }}
          />

          <UserDropdown />
        </div>
      </div>
      <Help isHelpOpen={isHelpOpen} toggleHelp={toggleHelp} />
    </header>
  );
};

export default Header;
